import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { useEffect, useState } from "react"
import BFText, { H3, H6, Tiny } from "@/components/standard/BFText"
import Animated, { FlipInXUp, FlipOutXDown } from "react-native-reanimated"

const animationDuration = 300
const TIMEBASED_PROMOTION = "slide_house_time_based_orig_fee_25"

const TimerDigit = ({ digit, letter }: { digit: number; letter: string }) => {
  const paddedDigit = digit.toString().padStart(2, "0")

  return (
    <Vertical className={"justify-center items-center overflow-hidden"}>
      <Animated.Text
        key={paddedDigit}
        allowFontScaling={false}
        style={{ fontSize: 18, fontWeight: "bold" }}
        entering={FlipInXUp.duration(animationDuration)}
        exiting={FlipOutXDown.duration(animationDuration)}
        className={"text-off-white text-center w-8"}
      >
        {paddedDigit}
      </Animated.Text>
      <Tiny className={"opacity-50 text-off-white uppercase"}>{letter}</Tiny>
    </Vertical>
  )
}

const TimerComponent = ({ futureDate }: { futureDate: Date }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(futureDate) - +new Date()
    return difference > 0 ? Math.floor(difference / 1000) : 0
  }

  const [time, setTime] = useState(calculateTimeLeft())

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(calculateTimeLeft())
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [futureDate])

  const hours = Math.floor(time / 3600)
  const minutes = Math.floor((time % 3600) / 60)
  const seconds = time % 60

  return (
    <Horizontal
      className={"bg-midnight-blue text-off-white rounded-md px-2 py-1 gap-0"}
    >
      <TimerDigit digit={hours} letter={"h"} />
      <H3 className={"text-off-white"}>:</H3>
      <TimerDigit digit={minutes} letter={"m"} />
      <H3 className={"text-off-white"}>:</H3>
      <TimerDigit digit={seconds} letter={"s"} />
    </Horizontal>
  )
}

export const TimeBasedOriginationDiscount = () => {
  const { loanApplication } = useLoanContext()

  const discount = loanApplication.discounts?.find(
    (d) => d?.promotion === TIMEBASED_PROMOTION
  )

  if (!discount || discount.status !== "ACTIVE") {
    return null
  }

  const futureData = discount.expiresAt
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      new Date(discount.expiresAt)
    : new Date()

  return (
    <Vertical className={"gap-2 py-4"}>
      <Horizontal
        className={
          "bg-grey rounded-md px-4 py-2 justify-between items-center border-light-grey border"
        }
      >
        <H6>
          Get a <BFText className={"bg-neon-yellow"}>.25%</BFText> origination
          fee discount{"\n"}for the next 24 hours—on us!*
        </H6>
        <TimerComponent futureDate={futureData} />
      </Horizontal>
      <Tiny>
        *Valid for one quote submitted within eligible timeframe and may not be
        applied to additional quotes{" "}
      </Tiny>
    </Vertical>
  )
}
